import styled from 'styled-components';
import { Container } from '../../components/Scaffolding/Container';

export const SwitchContainer = styled(Container)`
    display: flex;
    justify-content: flex-end;
`;